/**
* TelemetryContext.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { createValueMap } from "@microsoft/applicationinsights-core-js";
export var Extensions = createValueMap({
    UserExt: [0 /* UserExt */, "user"],
    DeviceExt: [1 /* DeviceExt */, "device"],
    TraceExt: [2 /* TraceExt */, "trace"],
    WebExt: [3 /* WebExt */, "web"],
    AppExt: [4 /* AppExt */, "app"],
    OSExt: [5 /* OSExt */, "os"],
    SdkExt: [6 /* SdkExt */, "sdk"],
    IntWebExt: [7 /* IntWebExt */, "intweb"],
    UtcExt: [8 /* UtcExt */, "utc"],
    LocExt: [9 /* LocExt */, "loc"],
    CloudExt: [10 /* CloudExt */, "cloud"]
});
export var AppExtensionKeys = createValueMap({
    id: [0 /* id */, "id"],
    ver: [1 /* ver */, "ver"],
    appName: [2 /* appName */, "name"],
    locale: [3 /* locale */, "locale"],
    expId: [4 /* expId */, "expId"],
    env: [5 /* env */, "env"]
});
export var WebExtensionKeys = createValueMap({
    domain: [0 /* domain */, "domain"],
    browser: [1 /* browser */, "browser"],
    browserVer: [2 /* browserVer */, "browserVer"],
    screenRes: [3 /* screenRes */, "screenRes"],
    userConsent: [4 /* userConsent */, "userConsent"],
    consentDetails: [5 /* consentDetails */, "consentDetails"]
});
export var UserExtensionKeys = createValueMap({
    locale: [0 /* locale */, "locale"],
    localId: [1 /* localId */, "localId"],
    id: [2 /* id */, "id"]
});
export var OSExtKeys = createValueMap({
    osName: [0 /* osName */, "name"],
    ver: [1 /* ver */, "ver"]
});
export var SDKExtKeys = createValueMap({
    ver: [0 /* ver */, "ver"],
    seq: [1 /* seq */, "seq"],
    installId: [2 /* installId */, "installId"],
    epoch: [3 /* epoch */, "epoch"]
});
export var IntWebExtKeys = createValueMap({
    msfpc: [0 /* msfpc */, "msfpc"],
    anid: [1 /* anid */, "anid"],
    serviceName: [2 /* serviceName */, "serviceName"]
});
export var UtcExtKeys = createValueMap({
    popSample: [0 /* popSample */, "popSample"],
    eventFlags: [1 /* eventFlags */, "eventFlags"]
});
export var LocExtKeys = createValueMap({
    tz: [0 /* tz */, "tz"]
});
export var SessionExtKeys = createValueMap({
    sessionId: [0 /* sessionId */, "sesId"]
});
export var DeviceExtKeys = createValueMap({
    localId: [0 /* localId */, "localId"],
    deviceClass: [1 /* deviceClass */, "deviceClass"],
    make: [2 /* make */, "make"],
    model: [3 /* model */, "model"]
});
export var CloudExtKeys = createValueMap({
    role: [0 /* role */, "role"],
    roleInstance: [1 /* roleInstance */, "roleInstance"],
    roleVer: [2 /* roleVer */, "roleVer"]
});
export var TraceExtKeys = createValueMap({
    traceId: [0 /* traceId */, "traceID"],
    traceName: [1 /* traceName */, "name"],
    parentId: [2 /* parentId */, "parentID"]
});
//# sourceMappingURL=ExtensionKeys.js.map